type Props = {
  size?: "sm" | "md";
};

export default function AdminBadge({ size = "sm" }: Props) {
  const isSm = size === "sm";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        fontFamily: "var(--f-label)",
        textTransform: "uppercase",
        letterSpacing: "0.16em",
        fontWeight: 700,
        fontSize: isSm ? "0.62rem" : "0.7rem",
        padding: isSm ? "2px 7px" : "3px 9px",
        background: "var(--c-coral)",
        color: "var(--c-sand)",
        borderRadius: "var(--r-pill)",
        lineHeight: 1.2,
      }}
    >
      Admin
    </span>
  );
}
